import { useQuery } from '@tanstack/react-query';
import { fetchShipmentAuditLogs } from '../data-provider/audit-logs';
import type { GetShipmentAuditLogsRequestParams } from '../data-provider/audit-logs/api';

export const useGetShipmentAuditLogs = (params: Partial<GetShipmentAuditLogsRequestParams>) => {
  return useQuery({
    queryKey: ['shipment-audit-logs', params.shipmentkey, params.ModuleId],
    queryFn: () => fetchShipmentAuditLogs(params as GetShipmentAuditLogsRequestParams),
    enabled: !!params.shipmentkey && !!params.ModuleId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
